import { render, staticRenderFns } from "./NotificationTicketList.vue?vue&type=template&id=3bfdaa94&scoped=true"
import script from "./NotificationTicketList.vue?vue&type=script&lang=js"
export * from "./NotificationTicketList.vue?vue&type=script&lang=js"
import style0 from "./NotificationTicketList.vue?vue&type=style&index=0&id=3bfdaa94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfdaa94",
  null
  
)

export default component.exports